/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLocationProducts200ResponseItemsInner } from './GetLocationProducts200ResponseItemsInner';
import {
    GetLocationProducts200ResponseItemsInnerFromJSON,
    GetLocationProducts200ResponseItemsInnerFromJSONTyped,
    GetLocationProducts200ResponseItemsInnerToJSON,
    GetLocationProducts200ResponseItemsInnerToJSONTyped,
} from './GetLocationProducts200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetLocationProducts200Response
 */
export interface GetLocationProducts200Response {
    /**
     * 
     * @type {Array<GetLocationProducts200ResponseItemsInner>}
     * @memberof GetLocationProducts200Response
     */
    items: Array<GetLocationProducts200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetLocationProducts200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationProducts200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocationProducts200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetLocationProducts200Response interface.
 */
export function instanceOfGetLocationProducts200Response(value: object): value is GetLocationProducts200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetLocationProducts200ResponseFromJSON(json: any): GetLocationProducts200Response {
    return GetLocationProducts200ResponseFromJSONTyped(json, false);
}

export function GetLocationProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationProducts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetLocationProducts200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetLocationProducts200ResponseToJSON(json: any): GetLocationProducts200Response {
    return GetLocationProducts200ResponseToJSONTyped(json, false);
}

export function GetLocationProducts200ResponseToJSONTyped(value?: GetLocationProducts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetLocationProducts200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

